export const SignatureSave = {
	NOT_STARTED: 'NOT_STARTED',
	STARTED: 'STARTED',
	COMPLETED: 'COMPLETED',
};

export const SignatureType = {
	DRAWN: 'drawn',
	TYPED: 'typed',
	UPLOADED: 'uploaded',
};

export const canvasDimesions = {
	width: 800,
	height: 200,
};

export const SIGNATURE_DRAWER_MAX_WIDTH = 850;
export const ANNOTATION_MODAL_WIDTH = 800;
export const UPLOAD_SIGNATURE_CLEAR_HEIGHT = 20;

// This determines a mathematial relationship between the vertical (font size)
// and horizontal (character width) dimensions of text. Since we use Courier
// in the final processed pdf, we use it's associated constant here so that
// the web app views look as close as possible to the final pdf
// Taken from https://pearsonified.com/2012/01/characters-per-line.php
export const CHARACTER_CONSTANT = 1.67;
